import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchHomeSalesData,
  fetchHomeCustomerData,
  fetchHomeProductData,
} from "../../api/home";

export const fetchSalesData = createAsyncThunk(
  "home/fetchSalesData",
  async ({ organization_id, branch_id }, { rejectWithValue }) => {
    try {
      const response = await fetchHomeSalesData(organization_id, branch_id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch sales data"
      );
    }
  }
);

export const fetchCustomerData = createAsyncThunk(
  "home/fetchCustomerData",
  async ({ organization_id }, { rejectWithValue }) => {
    try {
      const response = await fetchHomeCustomerData(organization_id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch customer data"
      );
    }
  }
);

export const fetchProductData = createAsyncThunk(
  "home/fetchProductData",
  async ({ organization_id, branch_id }, { rejectWithValue }) => {
    try {
      const response = await fetchHomeProductData(organization_id, branch_id);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch product data"
      );
    }
  }
);

const initialState = {
  value: {
    salesData: null,
    productData: null,
    customerData: null,
    loading: false,
    error: null,
    networkStatus: null,
  },
};

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {
    updateNetworkStatus: (state, data) => {
      if (data.payload.status === "online") {
        if (state.value.networkStatus === "offline") {
          state.value.networkStatus = "online";
        }
      } else {
        state.value.networkStatus = data.payload.status;
      }
    },
    clearHomeData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesData.pending, (state) => {
        state.value.loading = true;
        state.value.error = null;
      })
      .addCase(fetchSalesData.fulfilled, (state, action) => {
        state.value.loading = false;
        state.value.salesData = action.payload;
      })
      .addCase(fetchSalesData.rejected, (state, action) => {
        state.value.loading = false;
        state.value.error = action.payload;
      });

    builder
      .addCase(fetchCustomerData.pending, (state) => {
        state.value.loading = true;
        state.value.error = null;
      })
      .addCase(fetchCustomerData.fulfilled, (state, action) => {
        state.value.loading = false;
        state.value.customerData = action.payload;
      })
      .addCase(fetchCustomerData.rejected, (state, action) => {
        state.value.loading = false;
        state.value.error = action.payload;
      });

    builder
      .addCase(fetchProductData.pending, (state) => {
        state.value.loading = true;
        state.value.error = null;
      })
      .addCase(fetchProductData.fulfilled, (state, action) => {
        state.value.loading = false;
        state.value.productData = action.payload;
      })
      .addCase(fetchProductData.rejected, (state, action) => {
        state.value.loading = false;
        state.value.error = action.payload;
      });
  },
});

export const { clearHomeData, updateNetworkStatus } = homeSlice.actions;

export default homeSlice.reducer;
